const trackIdOperators = {
  contains: '*=',
  endsWith: '$=',
  equals: '=',
  startsWith: '^=',
};

const getTrackIdSelector = (value, condition = 'equals') => {
  const conditions = Object.keys(trackIdOperators);
  if (!conditions.includes(condition)) {
    return new Error(`onTrackId condition ${condition} is not one of: ${conditions.join(', ')}`);
  }
  const operator = trackIdOperators[condition];
  return `[data-track-id${operator}"${value}"]`;
};

module.exports = {
  getTrackIdSelector,
};
